import script from "./MainwaveTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MainwaveTable.vue?vue&type=script&setup=true&lang=js"

import "./MainwaveTable.vue?vue&type=style&index=0&id=8d89ca34&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d89ca34"]])

export default __exports__